import { render, staticRenderFns } from "./rule2.vue?vue&type=template&id=52ad12b9&scoped=true"
import script from "./rule2.vue?vue&type=script&lang=js"
export * from "./rule2.vue?vue&type=script&lang=js"
import style0 from "./rule2.vue?vue&type=style&index=0&id=52ad12b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad12b9",
  null
  
)

export default component.exports